import { AxiosInstance } from "axios"
import {
    ConfirmedDomain,
    CreateUpdateDomain,
    CreateUpdateUserGroup,
    DomainDetails,
    UserGroup,
    UserGroupDetails,
} from "./userGroupsTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum CompanyAdminUserGroupsQuery {
    LIST = "userGroups-for-company",
    DETAILS = "user-group-for-company",
    DOMAIN_DETAILS = "user-group-domain-details",
}

type UserGroupsForCompanyParams = Readonly<{
    companyId: number
}>

export type UserGroupsForCompanyResponse = Readonly<{
    userGroups: UserGroup[]
}>

export async function fetchUserGroupsForCompany(
    params: UserGroupsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UserGroupsForCompanyResponse> {
    const url = `/companies/${params.companyId}/userGroups`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}
type DeleteUserGroupForCompanyParams = Readonly<{
    userGroupId: number
}>

export async function deleteUserGroupForCompany(
    { userGroupId }: DeleteUserGroupForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/userGroups/${userGroupId}`)
    return data
}

type UserGroupForCompanyParams = Readonly<{
    userGroupId: string
}>

export type UserGroupForCompanyResponse = Readonly<{
    userGroup: UserGroupDetails
}>

export async function fetchUserGroupForCompany(
    params: UserGroupForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UserGroupForCompanyResponse> {
    const url = `/userGroups/${params.userGroupId}`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

export async function createUserGroupForCompany(
    { userGroup, companyId }: { userGroup: CreateUpdateUserGroup; companyId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/userGroups`,
        {
            userGroup: {
                ...userGroup,
                company: {
                    id: companyId,
                },
            },
        },
        {
            signal,
        },
    )
    return data
}

export async function updateUserGroupForCompany(
    { userGroup, userGroupId }: { userGroup: CreateUpdateUserGroup; userGroupId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/userGroups/${userGroupId}`,
        {
            userGroup,
        },
        {
            signal,
        },
    )

    return data
}

// DOMAINS
type DomainDetailsParams = Readonly<{
    domainId: number
}>

export type DomainDetailsResponse = Readonly<{
    domain: DomainDetails
}>

export async function fetchDomainDetails(
    params: DomainDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DomainDetailsResponse> {
    const url = `/domains/${params.domainId}`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

export type DomainResponse = Readonly<{
    domain: ConfirmedDomain
    serviceResponse: {
        displayMessage: string
    }
}>
export async function createDomain(
    { domain, userGroupId }: { domain: CreateUpdateDomain; userGroupId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DomainResponse> {
    const { data } = await axios.post(
        `/domains`,
        {
            domain: {
                ...domain,
                userGroup: {
                    id: userGroupId,
                },
            },
        },
        {
            signal,
        },
    )
    return data
}

export async function updateDomain(
    { domain, domainId }: { domain: CreateUpdateDomain; domainId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/domains/${domainId}`,
        {
            domain,
        },
        {
            signal,
        },
    )

    return data
}

type DeleteDomainParams = Readonly<{
    domainId: number
}>

export async function deleteDomain(
    { domainId }: DeleteDomainParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/domains/${domainId}`)
    return data
}
